import React from 'react'

import type { UploadIdentityType } from '../upload/types'
import { FileNameToolTip } from './FileNameToolTip'
import {
  BackToTheFront,
  CenterButtons,
  Content,
  FileListItem,
  IconButton,
  List,
  MessageBodyCenter,
  MessageBodyCenterBold,
  MessageBodyCenterFailure,
  MessageBodyCenterSmall,
  MessageBodyListBody,
  MessageBodyListHeaderBold,
  MessageBold,
  MessageListBodyCenterBold
} from './styled-components'
import type { FileStatus, UIConfigType } from './types'

type PartialFailurePageProps = {
  uiConfig: UIConfigType
  claimNumber: string
  successes: FileStatus[]
  unsupportedErrors: FileStatus[]
  networkErrors: FileStatus[]
  lostConnectionErrors: FileStatus[]
  failureHref: string
  failureSvgColor: string
  textColor: string
  successSvgColor: string
  successHref: string
  trackingError: boolean
  identity: UploadIdentityType
  onBackToUploadPage(): (event: React.SyntheticEvent) => void
  onFindClaimClick(event: React.SyntheticEvent): void
}

const PartialFailurePage = (props: PartialFailurePageProps) => {
  const {
    uiConfig,
    claimNumber,
    successes,
    textColor,
    unsupportedErrors,
    networkErrors,
    lostConnectionErrors,
    failureHref,
    failureSvgColor,
    successSvgColor,
    successHref,
    trackingError,
    identity,
    onBackToUploadPage,
    onFindClaimClick
  } = props

  return (
    <Content>
      {uiConfig.icon}
      <MessageBodyCenterFailure id="partial-tracking-message">
        {uiConfig.info.pre}
        <MessageBold>
          {claimNumber.toUpperCase()}
        </MessageBold>
        {uiConfig.info.post}
      </MessageBodyCenterFailure>
      <MessageBodyCenterSmall>
        Please note: larger files may take longer to process.
      </MessageBodyCenterSmall>
      {
        <List color={textColor} background="#FFFFFF">
          <MessageListBodyCenterBold>Files for upload</MessageListBodyCenterBold>
          <MessageBodyListHeaderBold> FAILED UPLOADED </MessageBodyListHeaderBold>
          <MessageBodyListBody>
            <FileListItem id="unsupported-list">
              {unsupportedErrors.map((s, i) =>
                <FileNameToolTip
                  key={i}
                  index={i}
                  fileName={s.fileName}
                  fileSize={s.fileSize}
                  color={textColor}
                  href={failureHref}
                  svgColor={failureSvgColor}
                />
              )}
            </FileListItem>
            <FileListItem id="network-list">
              {networkErrors.map((s, i) =>
                <FileNameToolTip
                  key={i}
                  index={i}
                  fileName={s.fileName}
                  fileSize={s.fileSize}
                  color={textColor}
                  href={failureHref}
                  svgColor={failureSvgColor}
                />
              )}
            </FileListItem>
            <FileListItem id="lost-connection-list">
              {lostConnectionErrors.map((s, i) =>
                <FileNameToolTip
                  key={i}
                  index={i}
                  fileName={s.fileName}
                  fileSize={s.fileSize}
                  color={textColor}
                  href={failureHref}
                  svgColor={failureSvgColor}
                />
              )}
            </FileListItem>
          </MessageBodyListBody>
        </List>
      }
      {
        <List color={textColor} background="#FFFFFF">
          <MessageBodyListHeaderBold> FILES UPLOADED </MessageBodyListHeaderBold>
          <MessageBodyListBody>
            <FileListItem id="success-list">
              {successes.map((s, i) =>
                <FileNameToolTip
                  key={i}
                  index={i}
                  fileName={s.fileName}
                  fileSize={s.fileSize}
                  color={textColor}
                  href={successHref}
                  svgColor={successSvgColor}
                />
              )}
            </FileListItem>
          </MessageBodyListBody>
        </List>
      }

      {!trackingError &&
        <MessageBodyCenterBold>{uiConfig.nextSteps}</MessageBodyCenterBold>
      }
      {!trackingError &&
        <MessageBodyCenter>
          {uiConfig.nextStepsCopy?.pre}{identity.email + '.'} {uiConfig.nextStepsCopy?.post}
        </MessageBodyCenter>
      }
      <br></br>
      <MessageBodyCenter>Retry failed files for <MessageBold>
        {claimNumber.toUpperCase()}
      </MessageBold> or start a new upload.</MessageBodyCenter>
      <CenterButtons>
        <IconButton onClick={onBackToUploadPage()}>
          {uiConfig.backButtonText}
        </IconButton>
        <BackToTheFront onClick={onFindClaimClick} href="#">NEW UPLOAD</BackToTheFront>
      </CenterButtons>
    </Content>
  )
}

export { PartialFailurePage }
